import { useContext } from 'react'
import { InternationalCalculatorContext } from '../../InternationalCalculatorContext'

export const useHandleCalculate = ({ serviceUrlPriceCalc, labels }) => {
    const {
        setErrorSelect,
        setErrorInputPostalCode,
        setInputError,
        setPrice,
        setWorkingDays,
        setMaxWeight,
        setShippingWeight,
        setZoneCount,
        setSubDisplayCategory,
        setDescriptionText,
        setSubmittedDimensions,
        setAdditionalPrice,
        setLoading,
        loading,
        setError,
        serviceType,
        destination,
        postalNumber,
        dimensions
    } = useContext(InternationalCalculatorContext)

    const handleCalculate = async () => {
        setErrorSelect(null)
        setErrorInputPostalCode(null)
        setInputError(null)
        setPrice(null)

        const { weight, length, width, height } = dimensions
        const weightValue = parseFloat(weight.replace(',', '.')) || 0

        let allowedWeight = serviceType === 'PICKUP_PARCEL' ? 20 : 30
        if (serviceType === 'BUSINESS_PARCEL' && ['DK', 'SE', 'FI'].includes(destination)) {
            allowedWeight = 35
        }

        let hasError = false

        if (!destination) {
            setErrorSelect(labels.countrySelectorErrorText)
            hasError = true
        }

        if (!postalNumber) {
            setErrorInputPostalCode(labels.postalErrorMessage)
            hasError = true
        }

        if (!weight) {
            setInputError(labels.weigthValueErrorMessage)
            hasError = true
        } else if (weightValue < 0.1 || weightValue > allowedWeight) {
            setInputError(labels.dimensionNotValidValueText)
            hasError = true
        } else {
            setInputError(null)
        }

        if (hasError) {
            return
        }

        if (!serviceType || !destination || !weight || !postalNumber) {
            setError(labels.errorMissingFields)
            setErrorSelect(!destination ? labels.countrySelectorErrorText : null)
            setErrorInputPostalCode(!postalNumber ? labels.postalErrorMessage : null)
            setInputError(!weight ? labels.weigthValueErrorMessage : null)
            return
        }

        const formatNumber = (num) => num ? parseFloat(num.replace(',', '.')) : 0

        const formattedDimensions = {
            weight: formatNumber(weight) * 1000,
            length: formatNumber(length),
            width: formatNumber(width),
            height: formatNumber(height)
        }

        setLoading(true)
        setError(null)
        setPrice(null)
        setWorkingDays(null)
        setMaxWeight(null)
        setShippingWeight(null)
        setZoneCount(null)

        try {
            const response = await fetch(
                `${serviceUrlPriceCalc}?postalNumber=${postalNumber}&weight=${formattedDimensions.weight}&length=${formattedDimensions.length}&width=${formattedDimensions.width}&height=${formattedDimensions.height}&service=${serviceType}&destination=${destination}`
            )

            const data = await response.json()

            if (data.priceWithoutVAT) {
                setPrice(data.priceWithoutVAT)
                setWorkingDays(data.workingDays)
                setMaxWeight(data.maxWeight)
                setShippingWeight(data.shippingWeight)
                setZoneCount(data.zoneCount)
                setSubDisplayCategory(data.subDisplayCategory)
                setDescriptionText(data.descriptionText)
                setSubmittedDimensions({
                    length: dimensions.length || '0',
                    width: dimensions.width || '0',
                    height: dimensions.height || '0'
                })

                if (data.priceAdditionalWithoutVAT) {
                    setAdditionalPrice(data.priceAdditionalWithoutVAT)
                }
            } else {
                setError(labels.errorNoPrice)
            }
        } catch (err) {
            setError(labels.errorFetching)
        } finally {
            setLoading(false)
        }
    }
  return {
    handleCalculate,
    loading
  }
}